import { svg } from 'lit-html';



const template = (project, data) => svg`
<a @click="${() => { data.selectProject(project); }}" class="situation-map-project-shape-container" data-status="${data.state.activeLegendaStatuses.filter(status => status.value == project.getStatus()).length > 0 ? 'active' : 'inactive'}" data-object-id="${project.getId()}" data-object-status="${project.getStatus()}">
	${(project => {
		switch(project.getSvgElementTagName()) {
		case 'polygon':
			return svg`<polygon class="situation-map-project-shape"  points="${project.getPointsValueForShape()}" ></polygon>`;
		case 'path':
			return svg`<path class="situation-map-project-shape" d="${project.getDValueForShape()}" ></path>`;
		case 'rect':
			return svg`<rect class="situation-map-project-shape" width="${project.getWidthValueForShape()}" height="${project.getHeightValueForShape()}" x="${project.getXValueForShape()}" y="${project.getYValueForShape()}"></rect>`;
		}
	})(project, data)}
</a>
`;

export default template;